// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"paper__visuallyhidden--FDhM1","focusable":"paper__focusable--uKZig","paper-style":"paper__paper-style--lTVfG","paperStyle":"paper__paper-style--lTVfG"};